'use strict';
var allInputs = document.querySelectorAll('form input');
var capitalize = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = allInputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var input = _step.value;
        var inputName = input.getAttribute('name');
        var inputId = input.getAttribute('id');
        var parentContainer = input.parentElement;
        var label = document.createElement('label');
        var formattedName = capitalize(inputName);
        label.classList.add('field-label');
        if (inputId) label.setAttribute('for', inputId);
        label.textContent = formattedName;
        input.setAttribute('placeholder', formattedName);
        parentContainer.append(label);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

//# sourceMappingURL=js_task_fix_form_DOM.a709b347.js.map
